import { useCallback, useMemo, useState } from "react";
import { getDateShown } from "./getDateShown";
import { getDateSelected } from "./getDateSelected";
import { DateShown } from "./DateShown";
import { DateSelected } from "./DateSelected";

/**
 * returns the current value and setter for dateSelected, the prop to pass to primereact's Calendar component containing the current selected time range
 * @param dateShown 
 * @param setUrlState 
 * @param state 
 * @returns 
 */
export const useDateSelected = <State>(
    dateShown: DateShown,
    setUrlState: (state: State & { dateShown: DateShown; }) => void,
    state: State
) => {
    /**
    * selectingDateRange is true while the user is in the middle of selecting a date range, i.e., they have selected the starting endpoint of the interval and have note yet selected the ending endpoint.
    */
    const [selectingDateRange, setSelectingDateRange] = useState(false);
    const dateSelected = useMemo(
        () => getDateSelected(dateShown, selectingDateRange),
        [dateShown, selectingDateRange]
    );
    const setDateSelected = useCallback(
        (dateSelected: Date | Date[] | undefined) => {
            const dateShown = getDateShown(dateSelected as DateSelected);
            setUrlState({ ...state, dateShown });

            if (Array.isArray(dateSelected) && dateSelected[1] === null) {
                setSelectingDateRange(true);
            } else {
                setSelectingDateRange(false);
            }
        },
        [setUrlState, state]
    );
    return { dateSelected, setDateSelected };
};
